import { useEffect, useState } from 'react';
import {
  billingErrorMessage,
  listAccountBilling,
  setAccountExempt,
  type AccountBillingRow,
} from '../../lib/billing-api';
import styles from './admin.module.css';

// Platform operator only: every account's plan and status, and per-account
// exemptions from metering.

export function BillingPlansSection({ onChange }: { onChange: () => void }) {
  const [accounts, setAccounts] = useState<AccountBillingRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    try {
      setAccounts(await listAccountBilling());
    } catch (err) {
      setError(billingErrorMessage(err, 'Could not load accounts.'));
    }
  }
  useEffect(() => { void load(); }, []);

  async function toggleExempt(a: AccountBillingRow) {
    try {
      await setAccountExempt(a.id, !a.exempt);
      await load();
      onChange();
    } catch (err) {
      setError(billingErrorMessage(err, 'Update failed.'));
    }
  }

  return (
    <>
      <h3 className={styles.label} style={{ marginTop: 32 }}>Accounts</h3>
      {error && <p className={styles.error} role="alert">{error}</p>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead><tr><th>Account</th><th>Plan</th><th>Status</th><th>Razorpay customer</th><th>Billing</th></tr></thead>
          <tbody>
            {accounts.map((a) => (
              <tr key={a.id}>
                <td>{a.name}</td>
                <td>{a.plan ?? 'Free'}</td>
                <td>{a.status ?? '—'}</td>
                <td className={styles.mono}>{a.razorpayCustomerId ?? '—'}</td>
                <td>
                  {a.exempt ? 'exempt' : 'metered'}{' '}
                  <button type="button" className={styles.buttonGhost} onClick={() => void toggleExempt(a)}>
                    {a.exempt ? 'start metering' : 'exempt'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
